import { render, staticRenderFns } from "./WhatsappDetailIncoming.vue?vue&type=template&id=5fe8e556&"
import script from "./WhatsappDetailIncoming.vue?vue&type=script&lang=ts&"
export * from "./WhatsappDetailIncoming.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports